/* eslint-disable no-restricted-syntax */
/* eslint-disable no-use-before-define */
import _ from 'lodash'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import config from '../../config/version.json'
import { useAppSelector } from '../AppStore'
import { clearActiveUser } from '../reducers/activeUser'
import { setAppVersion } from '../reducers/AppConfig'

/**
 * Handles logout if app version is bigger in major or minor
 * Updates stored app version
 */
export const useAppVersion = () => {
	const dispatch = useDispatch()
	const oldVersion = useAppSelector((state) => state.appConfig.appVersion)
	const newVersion = config.version

	useEffect(() => {
		if (oldVersion === undefined) {
			dispatch(clearActiveUser())
		}
		const oldSemver = parseSemver(oldVersion ?? '')
		const newSemver = parseSemver(newVersion)

		if (oldSemver && newSemver) {
			if (compareSemVer(newSemver, oldSemver) === 1) {
				if (newSemver[0] > oldSemver[0] || newSemver[1] > oldSemver[1]) {
					// newSemver is major or minor bigger than old
					dispatch(clearActiveUser())
				}
			}
		}

		if (oldVersion !== newVersion && parseSemver(newVersion)) {
			dispatch(setAppVersion(newVersion))
		}
	}, [])
}

function compareSemVer(lhs: string | SemVer, rhs: string | SemVer) {
	const ls = Array.isArray(lhs) ? lhs : parseSemver(lhs)
	const rs = Array.isArray(rhs) ? rhs : parseSemver(rhs)

	if (!ls || !rs) {
		return undefined
	}

	for (const [l, r] of _.zip(ls, rs)) {
		if (l! > r!) {
			return 1
		}
		if (l! < r!) {
			return -1
		}
	}

	return 0
}

function parseSemver(value: string) {
	const parts = value.split('.')
	if (parts.length !== 3) {
		return undefined
	}

	const partRegex = /[0-9]+/

	const [major, minor, patch] = parts
	const isValid = partRegex.test(major) && partRegex.test(minor) && partRegex.test(patch)

	if (isValid) {
		return [parseInt(major, 10), parseInt(minor, 10), parseInt(patch, 10)] as SemVer
	}

	return undefined
}

type SemVer = [number, number, number] & { __OPAQUE_TYPE: 'SemVer' }
